import React, { useContext } from "react";

import {
  OpinionConsumer,
  OpinionContextProps,
  OpinionProvider,
} from "@/contexts";
import { GlobalContext } from "@/contexts";
import { ORG_BILDTVAPP } from "@/service/Brands";
import { Opinion, OpinionResult } from "@/service/Model";

import BildTvAppThumbs from "./templates/bildTvApp/BildTvAppThumbs";
import ClassicThumbs from "./templates/classic/ClassicThumbs";

export type ThumbsContainerProps = {
  interaction: Opinion;
  interactionResults: OpinionResult;
};

export type ThumbsProps = {
  thumbsUpSelected: boolean;
  thumbsDownSelected: boolean;
  thumbsUpCount: number;
  thumbsDownCount: number;
  voted: boolean;
  onVote: (thumbUp: boolean) => void;
} & ThumbsContainerProps;

const ThumbsContainer: React.FC<ThumbsContainerProps> = (
  props: ThumbsContainerProps
): React.JSX.Element => {
  const globalContext = useContext(GlobalContext);
  const { interaction, interactionResults } = props;

  const renderTemplate = (
    opinionContext: OpinionContextProps
  ): React.JSX.Element => {
    const { opinionValue } = opinionContext;
    const { value } = interactionResults;

    const onVote = (thumbUp: boolean): void => {
      opinionContext.onThumbsAnswer(interaction.id, thumbUp ? 1 : 0);
    };

    const thumbsUpSelected = opinionValue?.answer === 1;
    const thumbsDownSelected = opinionValue?.answer === 0;

    const thumbsProps: ThumbsProps = {
      onVote,
      thumbsUpSelected,
      thumbsDownSelected,
      voted: thumbsUpSelected || thumbsDownSelected,
      thumbsDownCount: value[0],
      thumbsUpCount: value[1],
      ...props,
    };

    if (thumbsProps.thumbsUpSelected) {
      thumbsProps.thumbsUpCount++;
    }

    if (thumbsProps.thumbsDownSelected) {
      thumbsProps.thumbsDownCount++;
    }

    return interaction.organizationId === ORG_BILDTVAPP ? (
      <BildTvAppThumbs {...thumbsProps} />
    ) : (
      <ClassicThumbs {...thumbsProps} />
    );
  };

  return (
    <OpinionProvider
      interaction={interaction}
      interactionResults={interactionResults}
      preview={!!globalContext.query.preview}
    >
      <OpinionConsumer>
        {(opinionContext: OpinionContextProps) =>
          renderTemplate(opinionContext)
        }
      </OpinionConsumer>
    </OpinionProvider>
  );
};

export default ThumbsContainer;
export { ThumbsContainer };
